export default {
      id: "nav-cart-quantity-filled-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#nav-cart-quantity-filled",
      toString: function () {
        return this.url;
      }
    }